/**
 * 从商品 details_url 解析 URL 产品段（与 SearchResultAppPicker / helpArticleInfo 路由一致）
 */
export function extractProductAliasFromDetailsUrl(detailsUrl) {
    if (!detailsUrl) {
        return '';
    }
    var path = detailsUrl
        .replace(/^https?:\/\/[^/]+/i, '')
        .replace(/^\//, '')
        .split('?')[0];
    var parts = path.split('/').filter(Boolean);
    return parts[parts.length - 1] || '';
}
/** 帮助中心产品一览表 → 软件教程列表页，可选带上已选产品 */
export function buildHelpArticleListUrl(detailsUrl, classify) {
    if (classify === void 0) { classify = 'article'; }
    var alias = extractProductAliasFromDetailsUrl(detailsUrl);
    return alias ? "/".concat(classify, "/").concat(alias) : "/".concat(classify);
}
